import { render, staticRenderFns } from "./CategoryType.vue?vue&type=template&id=15512cc3&"
import script from "./CategoryType.vue?vue&type=script&lang=js&"
export * from "./CategoryType.vue?vue&type=script&lang=js&"
import style0 from "./CategoryType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports